import { useState, useEffect, useCallback } from "react";

// ─── WORD LISTS (6 lettere — modalità di prova) ───────────────────────────────

const DICT_IT = [
// A
"ABBACO", "ABBATE", "ABBAIA", "ABBAIO", "ABBINA", "ABBINO", "ABBONA", "ABDICA",
"ABITAI", "ABITUA", "ABIURA", "ABISSO", "ABOLII", "ABROGA", "ACACIA", "ACCADE",
"ACCEDO", "ACCUSA", "ACUIRE", "ACUITO", "ADAGIA", "ADAGIO", "ADATTA", "ADATTO",
"ADDOME", "ADDUCE", "ADOPRA", "ADOPRI", "ADOPRO", "ADESSA", "ADESSO", "ADOTTA",
"ADOTTI", "ADOTTO", "ADUNCO", "ADULTO", "AERARE", "AERATO", "AFASIA", "AFFAMA",
"AFFAMI", "AFFAMO", "AFFARI", "AFFIDA", "AFFILA", "AFFILI", "AFFILO", "AFFINA",
"AFFINE", "AFFOGA", "AFFOGI", "AFFOGO", "AFRORE", "AGENDA", "AGENTE", "AGGIRA",
"AGGIRI", "AGGIRO", "AGISCE", "AGNATO", "AGOGNA", "AGOGNI", "AGOGNO", "AGONIA",
"AGONIE", "AGOSTO", "AGRUME", "AGUZZO", "AIRONE", "ALBERO", "ALBINO", "ALCOVA",
"ALCUNE", "ALCUNO", "ALGIDO", "ALIENA", "ALLAGA", "ALLENA", "ALLENO", "ALLORA",
"ALLORO", "ALLUCE", "ALMENO", "ALPACA", "ALPINO", "ALTANA", "ALTARE", "ALTERA",
"ALTERO", "ALTRUI", "ALZARE", "ALZATA", "ALZATO", "AMANTE", "AMANTI", "AMBITO",
"AMENDA", "AMICHE", "AMMIRA", "AMMIRO", "AMORFA", "AMORFO", "AMPUTA", "AMPUTO",
"ANCORA", "ANDARE", "ANELLO", "ANEMIA", "ANGINA", "ANGOLO", "ANGORA", "ANITRA",
"ANNOSA", "ANNOSO", "ANNUSA", "ANNUSO", "ANSARE", "ANSIMO", "ANTICO", "APNEA",
"APOGEO", "APORIA", "APPENA", "APERTO", "APRICO", "APRILE", "APRIRE", "ARDORE",
"ARGANO", "ARGINE", "ARGUTO", "ARMATO", "ARMENO", "ARNESE", "ARRESO", "ARRIVO",
"ARSURA", "ASCESA", "ASPIDE", "ASSALE", "ASSOLO", "ASTICE", "ASTUTO", "ATENEO",
"ATLETA", "ATROCE", "ATTIMA", "ATTIMO", "ATTIRA", "ATTIRO", "ATTIVA", "ATTIVO",
"ATTORE", "AUDACE", "AUGURA", "AUGURI", "AUGURO", "AURORA", "AUTOMA", "AUTORE",
"AVANZA", "AVANZO", "AVARIA", "AVORIO", "AVVISO", "AVVITA", "AVVITO", "AZIONE",
"AZIONI", "AZZIMO",

// B
"BABELE", "BACCHE", "BALENA", "BARITE", "BARONE", "BASICO", "BASITA", "BESTIA",
"BEVUTO", "BIANCO", "BIBITA", "BIGLIA", "BIONDO", "BISCIA", "BITUME", "BONACE",
"BOSCHI", "BOTOLA", "BOVINO", "BRACCO", "BREZZA", "BRILLO", "BRIOSO", "BRONCO",
"BRULLO", "BRUTTO", "BUCATO", "BUFALO", "BUFERA", "BUTANO",

// C
"CABINA", "CADERE", "CADUTA", "CALCIO", "CALICE", "CALORE", "CAMBIA", "CAMICE",
"CANALE", "CANAPA", "CANCRO", "CANINO", "CANONE", "CAPACE", "CAPIRE", "CAPITO",
"CARENA", "CARICA", "CAROTA", "CASALE", "CASATO", "CASINO", "CATENA", "CAVARE",
"CAVOLO", "CELIBE", "CENERE", "CENTRO", "CERUME", "CHIARO", "CHIAVE", "CIALDE",
"CIGLIO", "CINEMA", "CINESE", "CINQUE", "CITARE", "CIVILE", "CODICE", "COFANO",
"COLATA", "COLERA", "COLINO", "COLITE", "COLORE", "COLTRE", "COMUNE", "CONCIO",
"CONDOR", "CONGIO", "CORNEA", "CORONA", "COSCIA", "COTONE", "COVARE", "CREATO",
"CRESCO", "CROSTA", "CUMULO", "CURARE", "CURATO",

// D
"DEBITO", "DECIMO", "DEDALO", "DEDICA", "DELIRI", "DENARO", "DENTRO", "DERIVE",
"DESTRO", "DEVOTO", "DIARIO", "DIFESA", "DINAMO", "DIRADA", "DIRAMA", "DISAGI",
"DITALE", "DIVANO", "DIVIDE", "DIVINO", "DOCILE", "DOMANI", "DONARE", "DOPPIO",
"DOTARE", "DOTATO", "DOVUTO", "DRAMMA", "DUELLO", "DURATA",

// E
"EBBENE", "EDITTO", "EGUALE", "ELENCO", "EMESSO", "ENORME", "ERARIO", "ERETTA",
"ERRATO", "ESATTO", "ESILIO", "ESISTE", "ESSERE", "ESTIVO", "ETERNO",

// F
"FABBRO", "FACILE", "FALENA", "FAMOSO", "FATICA", "FAVOLA", "FEBBRE", "FELINO",
"FEMORE", "FERITO", "FEROCE", "FIAMMA", "FIDARE", "FIGLIO", "FILARE", "FILATO",
"FINALE", "FINIRE", "FINITO", "FIOTTO", "FISICO", "FOGLIO", "FOLLIA", "FRASCA",
"FREDDO", "FRETTA", "FRONTE", "FRUTTO", "FUGACE", "FUMOSO", "FUTILE",

// G
"GALERA", "GELATO", "GHETTO", "GIALLO", "GIOIRE", "GIORNO", "GIUGNO", "GIUSTO",
"GLORIA", "GOCCIA", "GRAPPA", "GRASSO", "GRIGIO", "GROSSO", "GRUPPO", "GUANTO",
"GUERRA", "GUITTO",

// I
"IDEALE", "IGNOTO", "ILLESO", "ILLUSO", "IMBUTO", "IMPARO", "IMPERO", "IMPETO",
"INCAVO", "INCISO", "INCUBO", "INDICE", "INDOLE", "INERTE", "INFAME", "INFIDO",
"INNATO", "INSANO", "INTERO", "INTIMO", "INVASO", "INVITO", "IRONIA", "IRRITO",
"ISPIDO",

// L
"LACUNA", "LAGUNA", "LAMINA", "LANCIO", "LAVARE", "LAVATO", "LAVORO", "LEMURE",
"LENIRE", "LEPIDO", "LIBERO", "LIBIDO", "LIMITE", "LINGUA", "LISCIO", "LITIGO",
"LOGICA", "LONTRA", "LUCIDO", "LUGLIO", "LURIDO",

// M
"MAGICO", "MAGLIO", "MAGONE", "MALATO", "MANICO", "MANTRA", "MARCIA", "MARINO",
"MATITA", "MATURO", "MEGLIO", "MELONE", "MENTRE", "MERITI", "MESSIA", "METODO",
"MINUTO", "MIRINO", "MISERO", "MOBILE", "MODULO", "MOGLIE", "MOLINO", "MONACO",
"MONETA", "MOTORE", "MUCOSA", "MULINO", "MUSICA", "MUTARE", "MUTATO", "MUTILO",
"MUSCHI","MATURI",

// N
"NATURA", "NEBBIA", "NEMICO", "NOBILE", "NOMADE", "NOSTRO", "NOTARE", "NOTATO",
"NUCLEO", "NUMERO",

// O
"OCEANO", "OGNUNO", "OMESSO", "ONDOSO", "ONESTO", "ORARIO", "ORDINE", "ORGANO",
"ORNARE", "ORNATO", "ORTIVO", "OSCURO", "OSPITE", "OSTILE", "OTTIMO",

// P
"PADANO", "PALATO", "PALESE", "PANICO", "PARERE", "PAROLA", "PATIRE", "PATITO",
"PATRIA", "PAVONE", "PEDONE", "PENALE", "PENDIO", "PENOSO", "PEPITA", "PERIRE",
"PESARE", "PESATO", "PETALO", "PIETRA", "PIRATA", "PITONE", "PODERE", "POESIA",
"POGGIO", "POLIPO", "POMICE", "POPOLO", "POTERE", "PRESTO", "PREZZO", "PRIORE",
"PRONTO", "PUGILE", "PUNIRE", "PUNITO","PULITO",

// R
"RABBIA", "RADICE", "RAPIDO", "RECITA", "REGOLA", "REMOTO", "RIGIDO", "RIMANE",
"RINVIO", "RIPARO", "RIPIDO", "RISATA", "RODERE", "ROGITO", "ROMANO", "RONZIO",
"ROSATO", "ROVINA", "RUBINO", "RUGOSO",

// S
"SABATO", "SALIRE", "SALITO", "SALUTE", "SANGUE", "SAPERE", "SAPUTO", "SCATTO",
"SCELTA", "SCHEMA", "SCHIVO", "SCONTO", "SEMINO", "SENATO", "SERENO", "SEVERO",
"SICURO", "SILURO", "SIMILE", "SINODO", "SLITTA", "SMACCO", "SNELLO", "SOBRIO",
"SOLITO", "SOLUTO", "SPAZIO", "SPECIE", "SPEZIA", "SPORCO", "SPRECO", "SQUALO",
"STAMPA", "STANCO", "STILLA", "STIRPE", "STRAGI", "STRANO", "STRATO", "STUDIO",
"SUBIRE", "SUBITO", "SVELTA",

// T
"TACERE", "TALARE", "TALUNO", "TAPIRO", "TAVOLO", "TENACE", "TENERO", "TESORO",
"TIMIDO", "TIRANO", "TIRARE", "TIRATO", "TITOLO", "TOPINO", "TORNEO", "TOTALE",
"TRISTE", "TROPPO",

// U
"UGUALE", "UNGHIE", "URBANO", "USCIRE", "USCITO", "UTENZA", "UVETTA",

// V
"VAGARE", "VAGITO", "VALERE", "VALICO", "VALIDO", "VALORE", "VAPORE", "VEDOVA",
"VELENO", "VENIRE", "VENUTO", "VIGILE", "VIGORE", "VIPERA", "VIRILE", "VISIVO",
"VITALE", "VIVACE", "VIVIDO", "VOCALE", "VOLERE", "VOLUME", "VOMITO",

// Z
"ZONALE", "ZUFOLO"

].filter(w => w.length === 6).map(w => w.toUpperCase());


const DICT_EN = [
  // A
"ABLAZE","ABSORB","ACCENT","ACCESS","ACCORD","ACCUSE","ACHING","ACROSS","ACTIVE",
"ACTUAL","ADDICT","ADMIRE","ADMITS","ADVENT","ADVICE","ADVISE","AERIAL","AFFECT",
"AFFORD","AGENDA","AGENTS","AGEING","AGREED","ALBEIT","ALBUMS","ALERTS",
"ALLEGE","ALLIED","ALMOST","ALWAYS","AMBUSH","AMOUNT","ANIMAL",
"ANKLES","ANNUAL","ANTLER","ANYONE","ANYWAY","APPEAL","APPEAR","ARCHER","ARCHED",
"ARMOUR","AROUND","ARTIST","ASLEEP","ASSERT","ASSESS","ASSIGN",
"ASSIST","ASSURE","ATTACH","ATTACK","ATTAIN","ATTEND","ATTEST","ATTUNE","AUGUST",
"AUTHOR","AUTUMN","AVATAR","AVENGE","AVENUE","AVERSE","AVOWAL","AWOKEN",

// B
"BALLOT","BANANA","BARELY","BARIUM","BARREL","BASKET","BATTLE","BEARER",
"BEAUTY","BECKON","BEFORE","BEHALF","BEHAVE","BEHIND","BEHOLD","BELFRY","BELIEF",
"BELONG","BESTOW","BETTER","BEWARE","BEYOND","BITTER","BLAZED","BLIGHT","BLONDE",
"BLOUSE","BODILY","BORDER","BOTHER","BOTTLE","BOTTOM","BOUGHT","BOUNCE",
"BREEZE","BRIDGE","BRIGHT","BROKEN","BROKER","BRONZE","BRUISE","BUBBLE","BUDGET",
"BUFFET","BUNDLE","BURDEN","BUREAU","BUTTON","BUYING",

// C
"CALMLY","CANDLE","CANVAS","CARBON","CAREER","CASTLE","CASUAL","CAVING","CENSUS",
"CENTER","CHANGE","CHARGE","CHASED","CHOICE","CHOOSE","CHORUS","CHROME","CIRCLE",
"CITIES","CLASSY","CLEVER","CLIENT","CLOSED","CLOSER","COBALT","COMBAT","COMMIT",
"COMMON","COMPEL","COMPLY","CONCUR","CONFER","CONVOY","COPPER","CORNER",
"COWARD","CREATE","CREDIT","CRISIS","CRITIC","CHOSEN","CLENCH","CLERGY","CLUTCH",
"COFFIN","COHORT","COLUMN","COMEDY","COMING","COTTON",
"COURSE","COUSIN","CURVED","CUSTOM","CUTOFF","CYBORG",

// D
"DAMAGE","DANCER","DANGER","DARING","DARKEN","DAZZLE","DEBATE","DEBRIS","DECADE",
"DECENT","DECIDE","DEFEAT","DEFEND","DEFINE","DEGREE","DELAYS","DENIAL","DENOTE",
"DEPEND","DEPICT","DEPLOY","DESERT","DESIGN","DESIRE","DEVOID","DEVOTE","DIFFER",
"DIGEST","DIRECT","DIVIDE","DIVINE","DOMAIN","DONATE","DOTTED","DOUBLY","DRIVEN",
"DRIVER","DURING","DUSTED",

// E
"EARNED","EASILY","EFFECT","EFFORT","EITHER","EMBARK","EMERGE","EMPIRE","ENABLE",
"ENCODE","ENDURE","ENERGY","ENGAGE","ENGINE","ENOUGH","ENSURE","ENTIRE","ENTITY",
"ESCAPE","ETHICS","EVOLVE","EXCEED","EXCEPT","EXCITE","EXEMPT","EXHALE",
"EXPAND","EXPECT","EXPOSE","EXTEND","EXTENT","EXOTIC","EYEING",

// F
"FADING","FAILED","FALLEN","FAMINE","FAMOUS","FANNED","FATHOM","FAULTY","FEWEST",
"FIERCE","FIGURE","FILTER","FINGER","FINISH","FISTED","FITTED","FLINCH","FLYING",
"FONDER","FONDLE","FORAGE","FORBID","FORMAL","FOSSIL","FOSTER","FROZEN","FULFIL",
"FUNDED","FUNGAL","FUTURE","FABLED","FABRIC","FACTOR","FALLEN","FASTER","FATHER",
"FELLOW","FENNEL","FERRET","FESTER","FIDDLE","FRIGHT","FRINGE","FROLIC",

// G
"GALAXY","GALLOP","GARDEN","GARLIC","GATHER","GENDER","GENTLE","GLOBAL","GOBLIN",
"GOLDEN","GOVERN","GRAVEL","GRIEVE","GROVEL","GROUND","GUITAR","GUTTER","GAINED",
"GARNET","GARGLE","GASKET","GAZING","GENTLE","GIGGLE","GIRDLE","GIVING","GLANCE",
"GLIDER","GLITCH","GLOSSY","GLUTEN","GOBLET","GOSSIP","GOTTEN","GRACED","GRASSY",
"GRAVEL","GREASE","GREEDY","GRIMLY","GROOVE","GROTTO","GROUCH","GROWTH","GRUDGE",
"GRUMPY","GUIDED","GUINEA",

// H
"HAMMER","HANDLE","HAPPEN","HARDLY","HARMED","HATRED","HAZARD","HEALTH","HELMET",
"HERALD","HERBAL","HIDDEN","HIGHER","HIGHLY","HINDER","HOLLER","HONEST","HORNET",
"HORROR","HUMBLE","HUNGRY","HUNTER","HUSTLE","HYBRID","HARBOR","HEALER",
"HERMIT","HEROIC","HINDER","HISSED","HUSHED",

// I
"IGNORE","IMMUNE","IMPACT","IMPORT","IMPOSE","INCOME","INDEED","INJECT","INSANE",
"INSERT","INSIDE","INTACT","INTENT","INVADE","INVEST","ISLAND","ITCHED",
"IGNITE","IMPART","IMPEDE","INBORN","INDENT","INDUCT","INFANT",
"INFECT","INFLUX","INFORM","INHALE","INJECT","INNATE","INSIST","INTEND","INVITE",

// J
"JANGLE","JAGGED","JESTER","JOGGER","JOLTED","JOVIAL","JOYFUL","JUMBLE","JUNGLE",
"JUNIOR","JARGON","JUSTLY","JAILED","JAMMED","JARRED","JINXED","JOSTLE","JURIST",

// K
"KETTLE","KINDLE","KNIGHT","KERNEL","KIDNEY","KITTEN","KNIFED",

// L
"LANCER","LANDED","LAPSED","LASTED","LAUNCH","LAVISH","LEADER","LEAGUE",
"LEANER","LESSEN","LESSON","LETHAL","LIKELY","LINKED","LIVELY","LIZARD","LOCKED",
"LONELY","LONGER","LOPING","LOSING","LOTION","LOUDER","LOVING","LUXURY",
"LABORS","LAMENT","LARGER","LATENT","LATHER","LATTER","LAWFUL","LAXITY","LEGACY",
"LEGEND","LEPTON","LESSER","LEVELS","LINGER","LIQUID","LISTEN","LITTER","LOADED",
"LOCKER","LOOKER","LOOSEN","LUSTER","LUSTRE",

// M
"MAIDEN","MALICE","MANAGE","MANNER","MARGIN","MARKET","MASTER","MATRIX","MEADOW",
"MEDIAN","MENTAL","MENTOR","METEOR","METHOD","MIDWAY","MIRROR","MOBILE","MODERN",
"MODEST","MOMENT","MORTAL","MORTAR","MUSTER","MUTUAL","MYSELF","MANGLE","MARBLE",
"MARVEL","MENACE","MENTAL","MERELY","METALS","MINGLE","MISHAP","MISSED","MITTEN",
"MOBILE","MODULE","MONKEY","MORTAL","MOSTLY","MOTION","MOTIVE","MUMBLE",
"MURDER","MUSCLE","MUTANT","MUTATE","MUZZLE",

// N
"NAMELY","NAPKIN","NATURE","NEARBY",
"NEATLY","NEEDLE","NEGATE","NEPHEW","NICKEL","NIMBLE","NOBBLE","NOODLE","NORMAL",
"NOTION","NOZZLE","NUDGED",
"NAMELY","NAPKIN","NARROW","NATION","NEARLY","NEEDLE","NEGATE","NESTED",
"NIBBLE","NICELY","NOBODY","NOSING","NOTARY","NOTICE",
"NOVICE","NUZZLE",

// O
"OBTAIN","OFFEND","OPPOSE","OPTION","ORANGE","ORIGIN","ORPHAN","OUTFIT","OUTLAW",
"OUTPUT","OUTRUN","OWNING","OXYGEN","OBJECT","OBLIGE","OBSESS","ODDITY","ODIOUS",
"OFFEND","OFFSET","ONLINE","OPENLY","OPPOSE","ORDEAL","ORIENT","OUTBID",
"OUTLET",

// P
"PACIFY","PACKET","PALACE","PARENT","PARODY","PATROL","PATRON","PEDDLE","PIERCE",
"PILLAR","PIRATE","PLAGUE","PLANET","PLENTY","PLUNGE","POCKET","POLICE","POLICY",
"POLITE","PORTAL","POSTER","PREFER","PRIEST","PRINCE","PRISON","PROFIT","PROMPT",
"PROPER","PROVEN","PUBLIC","PURPLE","PURSUE","PUZZLE","PAGODA","PANDER","PARCEL",
"PARDON","PARROT","PARTLY","PASTED","PELLET","PONDER","POPLAR","PORTAL","POSTED",
"POTTER","POUTED","POWDER","PRAYER","PREACH","PRINCE","PRISON","PROPER","PROVEN",
"PUDDLE","PUNISH","PUPPET","PUSHED","PYTHON",

// Q
"QUAINT","QUARRY","QUENCH","QUIRKY","QUORUM","QUOTED","QUIVER",

// R
"RABBIT","RACKET","RANDOM","RANSOM","RATTLE","RAVAGE","RAVISH","REBORN","RECALL",
"RECENT","RECKON","RECORD","REDUCE","REFUGE","REGARD","REGIME","RELIEF","REMAIN",
"REMOTE","REMOVE","REPEAT","RESCUE","RESIDE","RESIST","RESULT","REVEAL","REVIVE",
"REWARD","RIDDLE","RITUAL","ROBUST","ROCKET","ROTTEN","RUGGED","RULING","RAMBLE",
"RARELY","RAZING","REASON","RECOIL","REDEEM","REFINE","REFORM","REFUSE","REFUTE",
"RELATE","RELENT","RENDER","REPAIR","REPEAL","REPORT","REPOSE","RESCUE",
"RETAIL","RETURN","REVAMP","REVOLT","RIPPLE","RISING","ROBBER","ROOTED",
"RUSTLE","RATTLE","RAVINE","READER","REAPER","RIBBON",

// S
"SADDEN","SAFELY","SAMPLE","SAVAGE","SCRIPT","SEARCH","SEASON","SECRET","SECTOR",
"SECURE","SELECT","SENATE","SERIAL","SETTLE","SEVERE","SHIELD","SIGNAL","SIMPLE",
"SINGER","SINGLE","SKETCH","SLIGHT","SMOOTH","SOCCER","SOCIAL","SOFTEN","SOLVED",
"SORTED","SOUGHT","SPIRIT","SPLASH","SPRAWL","SPREAD","SPRING","SQUARE","STABLE",
"STATIC","STATUE","STATUS","STEADY","STOLEN","STRICT","STRIKE","STRING","STRONG",
"STRUCK","STUPID","SUBMIT","SUDDEN","SUFFER","SUMMER","SUPPLY","SWITCH","SYMBOL",
"SADDLE","SAILED","SAILOR","SALMON","SALUTE","SAMPLE","SAVING",
"SAYING","SCARCE","SCENIC","SCHEME","SCREEN","SCROLL","SEALED","SECOND","SHIELD",
"SHIVER","SHRINE","SICKLE","SIGHED","SILENT","SINFUL",
"SISTER","SIZZLE","SKETCH","SLEEPY","SLOGAN","SLOPPY","SLOWLY","SLUDGE","SLYEST",
"SNEEZE","SOCKET","SOLEMN","SOOTHE","SORROW","SOVIET","SPEECH",
"SPILLS","SPINAL","SPOKEN","SPONGE","SPROUT","STAMEN","STARVE","STATIC",
"STENCH","STEREO","STICKY","STRIDE","STRIFE",
"STROKE","STROLL","SUBURB","SUMMIT","SUNKEN","SUNLIT","SURELY","SURFER",
"SWERVE",

// T
"TACKLE","TALENT","TARGET","TENANT","THEORY","THORNY","THRONE","TINKER",
"TISSUE","TOMATO","TONGUE","TOUCHY","TRAGIC","TRAUMA","TRAVEL","TREATY","TRICKY",
"TRIPLE","TROUGH","TUMBLE","TYRANT","TANGLE","TARTAN","TASSEL","TAVERN",
"TEMPLE","TENDER","TERROR","TICKLE","TIMBER","TINGLE","TINSEL","TIPPED","TOASTY",
"TOGGLE","TOILET","TOUCAN","TOWARD","TROPHY","TRYING","TUMULT","TUNNEL",
"TURBAN","TURTLE","TYCOON",

// U
"UMPIRE","UNABLE","UNDONE","UNFAIR","UNFOLD","UNHOLY","UNIQUE","UNLESS","UNLIKE",
"UNLOCK","UNREST","UNVEIL","UPDATE","UPHOLD","UPWARD","URGENT","USEFUL","UTMOST",
"UTOPIA","UPROAR","UPLIFT",

// V
"VACANT","VANISH","VANITY","VERIFY","VESSEL","VICTIM","VIRGIN","VIRTUE","VISION",
"VISUAL","VOICED","VOLLEY","VORTEX","VOTING","VULGAR","VARIED","VENDOR","VERBAL",
"VIABLE","VICTIM","VILIFY","VIOLET","VIRTUE","VOICED","VOLUME","VOWING",

// W
"WANDER","WARDEN","WARMTH","WEALTH","WEAPON","WEEKLY","WEIGHT","WIZARD","WONDER",
"WORTHY","WOUNDS","WREATH","WRENCH","WRITER","WALLET","WASTED","WATERY","WAVING",
"WEAKEN","WEEKLY","WHIMSY","WICKED","WILLOW","WITHIN","WOBBLE","WOEFUL","WOODEN",
"WORDED","WORSEN","WRAITH",

// Y
"YEARLY","YELLOW","YONDER","YANKED",

// Z
"ZEALOT","ZENITH","ZIPPER","ZOMBIE","ZONING","ZAPPER","ZAPPED",

].filter((w, i, arr) => w.length === 6 && arr.indexOf(w) === i)
 .map(w => w.toUpperCase());

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
const MAX_GUESSES = 6;
const WORD_LEN = 6;

const KEYBOARD = [
  ["Q","W","E","R","T","Y","U","I","O","P"],
  ["A","S","D","F","G","H","J","K","L"],
  ["ENTER","Z","X","C","V","B","N","M","⌫"]
];

const TEXTS = {
  it: {
    title: "SYNTHWORD",
    subtitle: "IL GIOCO DELLE PAROLE · 6 LETTERE",
    start: "GIOCA",
    howto: "Indovina la parola di 6 lettere in 6 tentativi",
    green: "🟩 Lettera corretta, posizione corretta",
    yellow: "🟨 Lettera corretta, posizione errata",
    gray: "⬜ Lettera non presente",
    win: ["FANTASTICO!", "ESATTO!", "PERFETTO!", "GENIALE!", "BRAVO!", "OTTIMO!"],
    lose: (w) => `La parola era: ${w}`,
    invalid: "Parola non valida!",
    short: "Troppo corta!",
    play_again: "RIGIOCA",
    attempts: "Tentativo",
    of: "di",
  },
  en: {
    title: "SYNTHWORD",
    subtitle: "THE WORD GAME · 6 LETTERS",
    start: "PLAY",
    howto: "Guess the 6-letter word in 6 tries",
    green: "🟩 Correct letter, correct spot",
    yellow: "🟨 Correct letter, wrong spot",
    gray: "⬜ Letter not in word",
    win: ["AMAZING!", "CORRECT!", "PERFECT!", "BRILLIANT!", "NICE!", "GREAT!"],
    lose: (w) => `The word was: ${w}`,
    invalid: "Not a valid word!",
    short: "Too short!",
    play_again: "PLAY AGAIN",
    attempts: "Attempt",
    of: "of",
  }
};

// ─── HELPERS ──────────────────────────────────────────────────────────────────
function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function evaluateGuess(guess, target) {
  const result = Array(WORD_LEN).fill("absent");
  const targetArr = target.split("");
  const guessArr = guess.split("");
  const used = Array(WORD_LEN).fill(false);
  for (let i = 0; i < WORD_LEN; i++) {
    if (guessArr[i] === targetArr[i]) {
      result[i] = "correct";
      used[i] = true;
    }
  }
  for (let i = 0; i < WORD_LEN; i++) {
    if (result[i] === "correct") continue;
    for (let j = 0; j < WORD_LEN; j++) {
      if (!used[j] && guessArr[i] === targetArr[j]) {
        result[i] = "present";
        used[j] = true;
        break;
      }
    }
  }
  return result;
}

// ─── STYLES ───────────────────────────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Rajdhani:wght@400;600;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg:        #0a0015;
    --bg2:       #12002a;
    --pink:      #ff2d78;
    --cyan:      #00f5ff;
    --purple:    #bf00ff;
    --gold:      #ffaa00;
    --green:     #00ff9f;
    --dark-grid: #1a0035;
    --tile-empty:#1c0040;
    --tile-fill: #2d0060;
    --text:      #f0e6ff;
    --dim:       #7a5a99;
  }

  body { background: var(--bg); font-family: 'Rajdhani', sans-serif; color: var(--text); }

  .sw-root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
    position: relative;
    background: var(--bg);
  }

  /* ── GRID BACKGROUND ── */
  .sw-root::before {
    content: '';
    position: fixed; inset: 0;
    background:
      linear-gradient(rgba(0,245,255,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,245,255,0.04) 1px, transparent 1px);
    background-size: 40px 40px;
    pointer-events: none;
    z-index: 0;
  }

  /* ── HORIZON GLOW ── */
  .sw-root::after {
    content: '';
    position: fixed;
    bottom: 0; left: 0; right: 0;
    height: 320px;
    background: linear-gradient(to top, rgba(191,0,255,0.18) 0%, transparent 100%);
    pointer-events: none;
    z-index: 0;
  }

  .sw-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 560px;
    padding: 0 12px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* ── HEADER ── */
  .sw-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 0 6px;
    border-bottom: 1px solid rgba(0,245,255,0.15);
    margin-bottom: 8px;
  }

  .sw-title {
    font-family: 'Orbitron', sans-serif;
    font-size: clamp(20px, 5.5vw, 30px);
    font-weight: 900;
    letter-spacing: 6px;
    background: linear-gradient(90deg, var(--pink), var(--cyan), var(--purple));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 18px var(--pink));
  }

  .sw-subtitle {
    font-family: 'Rajdhani', sans-serif;
    font-size: 10px;
    letter-spacing: 3px;
    color: var(--cyan);
    opacity: 0.7;
    margin-top: 2px;
    text-align: center;
  }

  /* ── BADGE 6 LETTERE ── */
  .sw-badge {
    display: inline-block;
    font-family: 'Orbitron', sans-serif;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 2px;
    padding: 3px 10px;
    border: 1px solid var(--purple);
    color: var(--purple);
    border-radius: 20px;
    box-shadow: 0 0 10px rgba(191,0,255,0.3);
    margin-top: 4px;
  }

  /* ── LANG TOGGLE ── */
  .lang-toggle-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 14px 0 4px;
  }

  .lang-label {
    font-family: 'Orbitron', sans-serif;
    font-size: 9px;
    letter-spacing: 3px;
    color: var(--dim);
  }

  .lang-toggle {
    position: relative;
    width: 90px;
    height: 30px;
    background: var(--tile-empty);
    border: 1px solid rgba(0,245,255,0.25);
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
  }

  .lang-toggle-option {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Orbitron', sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    color: var(--dim);
    transition: color 0.2s;
    z-index: 1;
    cursor: pointer;
  }

  .lang-toggle-option.active { color: var(--bg); }

  .lang-toggle-slider {
    position: absolute;
    top: 2px; bottom: 2px;
    width: calc(50% - 2px);
    background: linear-gradient(135deg, var(--cyan), var(--purple));
    border-radius: 2px;
    transition: left 0.25s cubic-bezier(0.4,0,0.2,1);
    box-shadow: 0 0 10px var(--cyan);
  }

  /* ── START SCREEN ── */
  .sw-start {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
    margin-top: 36px;
    padding: 32px 28px;
    background: rgba(18,0,42,0.85);
    border: 1px solid rgba(191,0,255,0.3);
    border-radius: 8px;
    width: 100%;
    box-shadow: 0 0 40px rgba(191,0,255,0.12), inset 0 0 30px rgba(0,0,0,0.4);
  }

  .sw-start-logo {
    font-family: 'Orbitron', sans-serif;
    font-size: clamp(26px, 7vw, 44px);
    font-weight: 900;
    background: linear-gradient(135deg, var(--pink) 0%, var(--cyan) 50%, var(--purple) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 24px var(--pink));
    text-align: center;
    letter-spacing: 8px;
  }

  .sw-howto {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .sw-howto-item {
    font-size: 13px;
    color: rgba(240,230,255,0.75);
    letter-spacing: 1px;
  }

  .sw-start-btn {
    font-family: 'Orbitron', sans-serif;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 5px;
    padding: 14px 40px;
    background: transparent;
    border: 2px solid var(--cyan);
    color: var(--cyan);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    overflow: hidden;
  }
  .sw-start-btn:hover {
    box-shadow: 0 0 24px var(--cyan), 0 0 50px rgba(0,245,255,0.15);
    transform: translateY(-2px);
  }

  /* ── GAME STATUS ── */
  .sw-status {
    font-family: 'Orbitron', sans-serif;
    font-size: 10px;
    letter-spacing: 3px;
    color: var(--cyan);
    opacity: 0.6;
    margin: 4px 0 8px;
  }

  /* ── TOAST ── */
  .sw-toast {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(26,0,53,0.97);
    border: 1px solid var(--pink);
    color: var(--pink);
    font-family: 'Orbitron', sans-serif;
    font-size: 12px;
    letter-spacing: 3px;
    padding: 10px 24px;
    border-radius: 4px;
    z-index: 100;
    box-shadow: 0 0 20px var(--pink);
    animation: toastIn 0.2s ease;
    text-align: center;
    max-width: 90vw;
  }

  @keyframes toastIn {
    from { opacity: 0; transform: translateX(-50%) translateY(-10px); }
    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
  }

  /* ── GRID ── */
  .sw-grid {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 10px 0;
  }

  .sw-row { display: flex; gap: 5px; }

  /* ── TILE — ridimensionato per 6 lettere ── */
  .sw-tile {
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Orbitron', sans-serif;
    font-size: 18px;
    font-weight: 700;
    border: 2px solid var(--dark-grid);
    background: var(--tile-empty);
    color: var(--text);
    border-radius: 4px;
    transition: border-color 0.1s, transform 0.1s;
    user-select: none;
  }

  .sw-tile.filled {
    border-color: rgba(191,0,255,0.5);
    background: var(--tile-fill);
    animation: tilePop 0.1s ease;
  }

  .sw-tile.shake { animation: tileShake 0.4s ease; }

  @keyframes tilePop {
    0%   { transform: scale(0.85); }
    60%  { transform: scale(1.08); }
    100% { transform: scale(1); }
  }

  @keyframes tileShake {
    0%,100% { transform: translateX(0); }
    20%     { transform: translateX(-6px); }
    40%     { transform: translateX(6px); }
    60%     { transform: translateX(-4px); }
    80%     { transform: translateX(4px); }
  }

  /* flip animations — 6 indici */
  .sw-tile.flip-0 { animation: tileFlip 0.5s 0.00s ease both; }
  .sw-tile.flip-1 { animation: tileFlip 0.5s 0.10s ease both; }
  .sw-tile.flip-2 { animation: tileFlip 0.5s 0.20s ease both; }
  .sw-tile.flip-3 { animation: tileFlip 0.5s 0.30s ease both; }
  .sw-tile.flip-4 { animation: tileFlip 0.5s 0.40s ease both; }
  .sw-tile.flip-5 { animation: tileFlip 0.5s 0.50s ease both; }

  @keyframes tileFlip {
    0%   { transform: rotateX(0); }
    49%  { transform: rotateX(-90deg); }
    50%  { transform: rotateX(-90deg); }
    100% { transform: rotateX(0); }
  }

  .sw-tile.correct {
    background: linear-gradient(135deg, #005533, #00ff9f22);
    border-color: var(--green);
    color: var(--green);
    box-shadow: 0 0 14px rgba(0,255,159,0.4);
  }
  .sw-tile.present {
    background: linear-gradient(135deg, #553300, #ffe60022);
    border-color: var(--gold);
    color: var(--gold);
    box-shadow: 0 0 14px rgba(255,170,0,0.35);
  }
  .sw-tile.absent {
    background: #160030;
    border-color: #3a1a5a;
    color: #5a3a7a;
  }

  /* win pulse — 6 indici */
  .sw-tile.win-pulse { animation: winPulse 0.6s ease both; }
  .sw-tile.win-pulse-0 { animation-delay: 0.00s; }
  .sw-tile.win-pulse-1 { animation-delay: 0.08s; }
  .sw-tile.win-pulse-2 { animation-delay: 0.16s; }
  .sw-tile.win-pulse-3 { animation-delay: 0.24s; }
  .sw-tile.win-pulse-4 { animation-delay: 0.32s; }
  .sw-tile.win-pulse-5 { animation-delay: 0.40s; }

  @keyframes winPulse {
    0%   { transform: scale(1);    box-shadow: 0 0 0 rgba(0,255,159,0); }
    50%  { transform: scale(1.18); box-shadow: 0 0 30px rgba(0,255,159,0.7); }
    100% { transform: scale(1); }
  }

  /* ── KEYBOARD ── */
  .sw-keyboard {
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin-top: 14px;
    width: 100%;
  }

  .sw-kb-row {
    display: flex;
    justify-content: center;
    gap: 5px;
  }

  .sw-key {
    min-width: 32px;
    height: 50px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Orbitron', sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    background: var(--tile-fill);
    border: 1px solid rgba(191,0,255,0.3);
    color: var(--text);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
  .sw-key:hover {
    background: rgba(191,0,255,0.25);
    border-color: var(--purple);
    box-shadow: 0 0 10px rgba(191,0,255,0.3);
  }
  .sw-key:active { transform: scale(0.93); }

  .sw-key.wide { min-width: 54px; font-size: 8px; letter-spacing: 1px; }

  .sw-key.correct {
    background: linear-gradient(135deg, #004428, #00ff9f22);
    border-color: var(--green); color: var(--green);
    box-shadow: 0 0 8px rgba(0,255,159,0.3);
  }
  .sw-key.present {
    background: linear-gradient(135deg, #442200, #ffe60022);
    border-color: var(--gold); color: var(--gold);
    box-shadow: 0 0 8px rgba(255,170,0,0.25);
  }
  .sw-key.absent { background: #0e001f; border-color: #280050; color: #3d2060; }

  /* ── RESULT ── */
  .sw-result {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .sw-result-msg {
    font-family: 'Orbitron', sans-serif;
    font-size: clamp(14px,3.5vw,19px);
    font-weight: 900;
    letter-spacing: 5px;
    background: linear-gradient(90deg, var(--pink), var(--cyan));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 12px var(--pink));
    text-align: center;
  }

  .sw-result-word {
    font-family: 'Orbitron', sans-serif;
    font-size: 13px;
    letter-spacing: 4px;
    color: var(--gold);
    opacity: 0.9;
    text-align: center;
  }

  .sw-replay-btn {
    font-family: 'Orbitron', sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 4px;
    padding: 12px 30px;
    background: transparent;
    border: 2px solid var(--pink);
    color: var(--pink);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .sw-replay-btn:hover {
    box-shadow: 0 0 20px var(--pink), 0 0 40px rgba(255,45,120,0.15);
    transform: translateY(-2px);
  }

  /* ── SCANLINES ── */
  .sw-scanlines {
    pointer-events: none;
    position: fixed; inset: 0;
    z-index: 200;
    background: repeating-linear-gradient(
      0deg, transparent, transparent 2px,
      rgba(0,0,0,0.06) 2px, rgba(0,0,0,0.06) 4px
    );
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 420px) {
    .sw-tile { width: 44px; height: 44px; font-size: 15px; }
    .sw-key  { min-width: 26px; height: 44px; font-size: 9px; }
    .sw-key.wide { min-width: 46px; }
  }
`;

// ─── COMPONENTS ───────────────────────────────────────────────────────────────

function StyleInjector() {
  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);
  return null;
}

function LangToggle({ lang, onChange }) {
  const isEN = lang === "en";
  return (
    <div className="lang-toggle-wrap">
      <span className="lang-label">LANG</span>
      <div className="lang-toggle" onClick={() => onChange(isEN ? "it" : "en")}>
        <div className="lang-toggle-slider" style={{ left: isEN ? "calc(50% + 2px)" : "2px" }} />
        <div className={`lang-toggle-option${!isEN ? " active" : ""}`}>IT</div>
        <div className={`lang-toggle-option${isEN ? " active" : ""}`}>EN</div>
      </div>
    </div>
  );
}

function StartScreen({ lang, onLangChange, onStart }) {
  const t = TEXTS[lang];
  return (
    <div className="sw-start">
      <div className="sw-start-logo">{t.title}</div>
      <div className="sw-badge">6 {lang === "it" ? "LETTERE" : "LETTERS"}</div>
      <LangToggle lang={lang} onChange={onLangChange} />
      <div className="sw-howto">
        <div className="sw-howto-item">{t.howto}</div>
        <div className="sw-howto-item">{t.green}</div>
        <div className="sw-howto-item">{t.yellow}</div>
        <div className="sw-howto-item">{t.gray}</div>
      </div>
      <button className="sw-start-btn" onClick={onStart}>{t.start}</button>
    </div>
  );
}

function Tile({ letter, state, flipIdx, shake, winPulse }) {
  let cls = "sw-tile";
  if (letter) cls += " filled";
  if (state) {
    cls += ` ${state}`;
    if (flipIdx !== undefined) cls += ` flip-${flipIdx}`;
  }
  if (shake) cls += " shake";
  if (winPulse !== undefined) cls += ` win-pulse win-pulse-${winPulse}`;
  return <div className={cls}>{letter}</div>;
}

function Grid({ guesses, evaluations, currentGuess, shakeRow, winRow }) {
  const rows = [];
  for (let r = 0; r < MAX_GUESSES; r++) {
    const cells = [];
    const isSubmitted = r < guesses.length;
    const isCurrent   = r === guesses.length;
    for (let c = 0; c < WORD_LEN; c++) {
      let letter = "", state = null, flipIdx, shake = false, winPulse;
      if (isSubmitted) {
        letter  = guesses[r][c] || "";
        state   = evaluations[r]?.[c] || null;
        flipIdx = c;
        if (winRow === r) winPulse = c;
      } else if (isCurrent) {
        letter = currentGuess[c] || "";
        shake  = shakeRow === r;
      }
      cells.push(<Tile key={c} letter={letter} state={state} flipIdx={flipIdx} shake={shake} winPulse={winPulse} />);
    }
    rows.push(<div className="sw-row" key={r}>{cells}</div>);
  }
  return <div className="sw-grid">{rows}</div>;
}

function Keyboard({ keyStates, onKey }) {
  return (
    <div className="sw-keyboard">
      {KEYBOARD.map((row, ri) => (
        <div className="sw-kb-row" key={ri}>
          {row.map((k) => {
            const isWide = k === "ENTER" || k === "⌫";
            const ks = keyStates[k] || "";
            return (
              <button
                key={k}
                className={`sw-key${isWide ? " wide" : ""}${ks ? " " + ks : ""}`}
                onClick={() => onKey(k)}
              >
                {k}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}

// ─── MAIN GAME ────────────────────────────────────────────────────────────────
export default function SynthwaveWordle6() {
  const [screen,     setScreen]     = useState("start");
  const [lang,       setLang]       = useState("it");
  const [target,     setTarget]     = useState("");
  const [guesses,    setGuesses]    = useState([]);
  const [evaluations,setEvaluations]= useState([]);
  const [current,    setCurrent]    = useState("");
  const [gameOver,   setGameOver]   = useState(false);
  const [won,        setWon]        = useState(false);
  const [toast,      setToast]      = useState("");
  const [shakeRow,   setShakeRow]   = useState(null);
  const [winRow,     setWinRow]     = useState(null);

  const dict = lang === "it" ? DICT_IT : DICT_EN;
  const t    = TEXTS[lang];

  function startGame(l = lang) {
    const d = l === "it" ? DICT_IT : DICT_EN;
    setTarget(getRandom(d));
    setGuesses([]); setEvaluations([]); setCurrent("");
    setGameOver(false); setWon(false);
    setToast(""); setShakeRow(null); setWinRow(null);
    setScreen("game");
  }

  function showToast(msg) {
    setToast(msg);
    setTimeout(() => setToast(""), 1800);
  }

  // Key states for keyboard colouring
  const keyStates = {};
  guesses.forEach((g, ri) => {
    g.split("").forEach((ch, ci) => {
      const s = evaluations[ri]?.[ci];
      if (!s) return;
      const prev = keyStates[ch];
      if (prev === "correct") return;
      if (prev === "present" && s !== "correct") return;
      keyStates[ch] = s;
    });
  });

  const handleKey = useCallback((k) => {
    if (gameOver || screen !== "game") return;

    if (k === "⌫" || k === "BACKSPACE") {
      setCurrent(c => c.slice(0, -1));
      return;
    }

    if (k === "ENTER") {
      if (current.length < WORD_LEN) {
        showToast(t.short);
        setShakeRow(guesses.length);
        setTimeout(() => setShakeRow(null), 500);
        return;
      }
      if (!dict.includes(current)) {
        showToast(t.invalid);
        setShakeRow(guesses.length);
        setTimeout(() => setShakeRow(null), 500);
        return;
      }
      const eval_ = evaluateGuess(current, target);
      const newGuesses = [...guesses, current];
      const newEvals   = [...evaluations, eval_];
      setGuesses(newGuesses);
      setEvaluations(newEvals);
      setCurrent("");

      if (current === target) {
        setWon(true); setGameOver(true);
        const ri = newGuesses.length - 1;
        setTimeout(() => {
          setWinRow(ri);
          showToast(t.win[Math.min(ri, t.win.length - 1)]);
        }, 350);
      } else if (newGuesses.length >= MAX_GUESSES) {
        setGameOver(true);
        setTimeout(() => showToast(t.lose(target)), 350);
      }
      return;
    }

    if (/^[A-Z]$/i.test(k) && current.length < WORD_LEN) {
      setCurrent(c => (c + k.toUpperCase()).slice(0, WORD_LEN));
    }
  }, [current, guesses, evaluations, target, gameOver, screen, dict, t]);

  // Physical keyboard support
  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey || e.altKey || e.metaKey) return;
      const k = e.key.toUpperCase();
      if (k === "BACKSPACE")   handleKey("⌫");
      else if (k === "ENTER")  handleKey("ENTER");
      else if (/^[A-Z]$/.test(k)) handleKey(k);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [handleKey]);

  function handleLangChange(l) {
    setLang(l);
    if (screen === "game") startGame(l);
  }

  const attemptInfo = screen === "game" && !gameOver
    ? `${t.attempts} ${guesses.length + 1} ${t.of} ${MAX_GUESSES}`
    : "";

  return (
    <>
      <StyleInjector />
      <div className="sw-scanlines" />
      <div className="sw-root">
        <div className="sw-content">

          {/* HEADER */}
          <div className="sw-header">
            <div style={{ textAlign: "center" }}>
              <div className="sw-title">{t.title}</div>
              <div className="sw-subtitle">{t.subtitle}</div>
            </div>
          </div>

          {/* START SCREEN */}
          {screen === "start" && (
            <StartScreen lang={lang} onLangChange={setLang} onStart={() => startGame(lang)} />
          )}

          {/* GAME SCREEN */}
          {screen === "game" && (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 8 }}>
                <LangToggle lang={lang} onChange={handleLangChange} />
                {attemptInfo && <div className="sw-status">{attemptInfo}</div>}
              </div>

              <Grid
                guesses={guesses}
                evaluations={evaluations}
                currentGuess={current}
                shakeRow={shakeRow}
                winRow={winRow}
              />

              <Keyboard keyStates={keyStates} onKey={handleKey} />

              {gameOver && (
                <div className="sw-result">
                  {won
                    ? <div className="sw-result-msg">{t.win[Math.min(guesses.length - 1, t.win.length - 1)]}</div>
                    : <div className="sw-result-word">{t.lose(target)}</div>
                  }
                  <button className="sw-replay-btn" onClick={() => startGame(lang)}>
                    {t.play_again}
                  </button>
                </div>
              )}
            </>
          )}

        </div>
        {toast && <div className="sw-toast">{toast}</div>}
      </div>
    </>
  );
}
